"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAndPopulateSuggestedContacts_1 = require("owa-recipient-common/lib/actions/getAndPopulateSuggestedContacts");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('showHideFindResult')(function showHideFindResult(recipientWell, shouldShowFindResult, shouldClearFindResult) {
    var findResultCount = recipientWell.findResultSet ? recipientWell.findResultSet.length : 0;
    recipientWell.findResultHightlightIndex = -1;
    if (shouldClearFindResult && findResultCount) {
        // Clear existing find result if are not explicitly preserving the result.
        recipientWell.findResultSet.splice(0, findResultCount);
    }
    if (shouldShowFindResult) {
        if (recipientWell.queryString.length == 0 && !recipientWell.inForceResolve) {
            // With no query string, get our suggested contacts list.
            getAndPopulateSuggestedContacts_1.default(recipientWell.findResultSet, recipientWell.recipients);
        }
        else {
            // If we have (non suggested contacts) results, highlight the first (or the search box if no results).
            recipientWell.findResultHightlightIndex = 0;
        }
    }
    recipientWell.shouldShowFindResult = shouldShowFindResult;
});
//# sourceMappingURL=showHideFindResult.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/showHideFindResult.js
// module id = 2616
// module chunks = 2 3 4 45